import React, { useEffect } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { StyledButton } from '../../../Components/Generics.styled';

import TextField from '@mui/material/TextField';

const SelectAHeadlineContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    align-items: center;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: 600px;
`;

const SelectAHeadline = (props) => {
    const {
        handleNavButtonNext,
        handleNavButtonBack,
        setPageIndex,
        role,
        leadGenerationData,
        setLeadGenerationData,
    } = props;

    const handleBackButton = () => {
        if (role.isAdvertiser) {
            setPageIndex(0);
        } else {
            handleNavButtonBack();
        }
    };
    return (
        <SelectAHeadlineContainer>
            <Title>Create a Headline</Title>
            <StyledTextField
                id="headline-text"
                label="Headline"
                placeholder="Enter your headline here"
                value={
                    leadGenerationData?.theme?.headline ? leadGenerationData?.theme?.headline : ''
                }
                onChange={(e) =>
                    setLeadGenerationData({
                        ...leadGenerationData,
                        theme: { ...leadGenerationData.theme, headline: e.target.value },
                    })
                }
                variant="outlined"
                required
                error={leadGenerationData?.theme?.headline === ''}
            />
            <br />
            <StyledTextField
                id="sub-text"
                label="Subtext"
                placeholder="Enter your subtext here"
                value={leadGenerationData?.theme?.subtext ? leadGenerationData?.theme?.subtext : ''}
                onChange={(e) =>
                    setLeadGenerationData({
                        ...leadGenerationData,
                        theme: { ...leadGenerationData?.theme, subtext: e.target.value },
                    })
                }
                variant="outlined"
            />
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleBackButton()}
                >
                    Back
                </StyledButton>

                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={leadGenerationData?.theme?.headline === ''}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </SelectAHeadlineContainer>
    );
};

SelectAHeadline.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        theme: propTypes.shape({ headline: propTypes.string, subtext: propTypes.string }),
    }),
    setLeadGenerationData: propTypes.func,
    role: propTypes.shape({ isAdvertiser: propTypes.bool }),
    setPageIndex: propTypes.func,
};

SelectAHeadline.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: {},
    setLeadGenerationData: () => {},
    role: '',
};
export default SelectAHeadline;
